export default __webpack_public_path__ + "static/media/001-grafico-de-ondas.722b69ea.png";